import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Tile } from '../chunk';
import { formatFileSize, getServerURL } from '../../util';

//@TODO put in conf
const path = getServerURL();
export default class CommentAttachment extends React.Component {

	render() {

		const file = this.props.file;
        let lightbox = false;
        let linkUrl = path + '/upload/' + file.filename;

		let media = <FontAwesomeIcon icon="sticky-note" size="2x" />;
        if(file.type.match('image.*')) {
            lightbox = true;
            linkUrl = path + '/thumb/1280/' + file.filename;
            media = <img src={path + '/thumb/128/' + file.filename} alt="" />;
        }

		return (
            <Tile url={linkUrl} target="_blank" lightbox={lightbox} key={file.id}>
                <div className='card'>
                    <div className="card-media card-media--large">
                        {media}
                    </div>
					<div className="card-content card-content--inline">
                        {file.name}
                        <div className="meta" style={{marginTop:'0.25rem'}}>{formatFileSize(file.size)}</div>
                    </div>
                </div>
            </Tile>
        );
	}
};


// WEBPACK FOOTER //
// ./src/components/comment/CommentAttachment.js